module.exports = __webpack_public_path__ + "static/media/iphone_max.0bc4001d.png";